module.exports = __webpack_public_path__ + "img/right.d7121d65.webp";